var _circle, _g, _circle2, _circle3, _circle4, _circle5, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyPayments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 118,
    viewBox: "0 0 152 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 52,
    r: 52,
    fill: "#EAECF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_687_18873)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12,
    width: 115,
    height: 72,
    rx: 6,
    fill: "url(#paint0_linear_687_18873)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 26,
    width: 20,
    height: 15,
    rx: 2,
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.667,
    cy: 32.3334,
    r: 8.33333,
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.667,
    cy: 32.3333,
    r: 8.33333,
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 73.6667C28 72.7462 28.7462 72 29.6667 72H46.3333C47.2538 72 48 72.7462 48 73.6667C48 74.5871 47.2538 75.3333 46.3333 75.3333H29.6667C28.7462 75.3333 28 74.5871 28 73.6667Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 73.6667C53 72.7462 53.7462 72 54.6667 72H71.3333C72.2538 72 73 72.7462 73 73.6667C73 74.5871 72.2538 75.3333 71.3333 75.3333H54.6667C53.7462 75.3333 53 74.5871 53 73.6667Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 73.6667C78 72.7462 78.7462 72 79.6667 72H96.3333C97.2538 72 98 72.7462 98 73.6667C98 74.5871 97.2538 75.3333 96.3333 75.3333H79.6667C78.7462 75.3333 78 74.5871 78 73.6667Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 73.6667C103 72.7462 103.746 72 104.667 72H121.333C122.254 72 123 72.7462 123 73.6667C123 74.5871 122.254 75.3333 121.333 75.3333H104.667C103.746 75.3333 103 74.5871 103 73.6667Z",
    fill: "#D0D5DD"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 5,
    r: 5,
    fill: "#F2F4F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 109,
    r: 7,
    fill: "#F2F4F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 35,
    r: 7,
    fill: "#F2F4F7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 8,
    r: 4,
    fill: "#F2F4F7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_687_18873)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 70,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#344054",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 83.5C70.2016 83.5 65.5 88.2016 65.5 94C65.5 99.7984 70.2016 104.5 76 104.5C81.7984 104.5 86.5 99.7984 86.5 94C86.5 88.2016 81.7984 83.5 76 83.5ZM76 102.719C71.1859 102.719 67.2812 98.8141 67.2812 94C67.2812 89.1859 71.1859 85.2812 76 85.2812C80.8141 85.2812 84.7188 89.1859 84.7188 94C84.7188 98.8141 80.8141 102.719 76 102.719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8746 98.125C74.8746 98.4234 74.9932 98.7095 75.2041 98.9205C75.4151 99.1315 75.7013 99.25 75.9996 99.25C76.298 99.25 76.5842 99.1315 76.7951 98.9205C77.0061 98.7095 77.1246 98.4234 77.1246 98.125C77.1246 97.8266 77.0061 97.5405 76.7951 97.3295C76.5842 97.1185 76.298 97 75.9996 97C75.7013 97 75.4151 97.1185 75.2041 97.3295C74.9932 97.5405 74.8746 97.8266 74.8746 98.125ZM75.4371 95.5H76.5621C76.6653 95.5 76.7496 95.4156 76.7496 95.3125V88.9375C76.7496 88.8344 76.6653 88.75 76.5621 88.75H75.4371C75.334 88.75 75.2496 88.8344 75.2496 88.9375V95.3125C75.2496 95.4156 75.334 95.5 75.4371 95.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_687_18873",
    x: 1.33333,
    y: 12,
    width: 148.333,
    height: 105.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.33333,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_687_18873"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.66667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.33333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_687_18873"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.33333,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_687_18873"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16.6667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_687_18873",
    result: "effect2_dropShadow_687_18873"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_687_18873",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_687_18873",
    x: 44,
    y: 62,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_687_18873"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_687_18873",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_687_18873",
    x1: 22.0049,
    y1: 83.1477,
    x2: 19.9135,
    y2: 17.2505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FAFB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPayments);
export default __webpack_public_path__ + "static/media/emptyPayments.087f0d32fb4c32170755177c962975c4.svg";
export { ForwardRef as ReactComponent };